import { createFileRoute } from '@tanstack/react-router';
import { PayoutsPage } from '../components/pages/PayoutsPage/PayoutsPage';

export const Route = createFileRoute('/account/payouts')({
  component: PayoutsPage,
});
